import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, deleteDataList, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';

import { PRD3012_R01LotDto, PRD3012_R01Dto, PRD3012_R01HeaderDto, PRD3012_R01InspectDto, PRD3012_R01ProductResultDto, PRD3012_R01DetailDto } from './Dto_PRD3012_R01';
import { PRD3012_R01Filter } from "./Store_PRD3012_R01";

const baseUrl = `${config.apiUrl}/PRD3012_R01`;

const getParams = (filter: Partial<PRD3012_R01Filter>, listLength?: number) => {
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		compCd: filter.compCd || undefined,
		compNm: filter.compNm || undefined,
		workplaceCd: filter.workplaceCd || undefined,
		itemCd: filter.itemCd || undefined,
		itemNm: filter.itemNm || undefined,
		workEmp: filter.workEmp || undefined,
		workEmpNm: filter.workEmpNm || undefined,
		labelPrintAuto: filter.labelPrintAuto || undefined,
		listLength: listLength || 0
	}
}

export const getPRD3012_R01List = async (option: string, params: Partial<PRD3012_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<PRD3012_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD3012_R01AllCount = async (params: Partial<PRD3012_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getPRD3012_R01One = async (productOrderNo: string) => {
	const url = `${baseUrl}/one/${productOrderNo}`;
	return await getData<ResponseDto<PRD3012_R01HeaderDto>>(url);
}

export const getPRD3012_R01ProductResultList = async (productResultNo: string) => {
	const url = `${baseUrl}/productResult/${productResultNo}`;
	return await getData<ResponseDto<PRD3012_R01ProductResultDto>>(url);
}

export const getPRD3012_R01LotList = async (itemCd: string) => {
	const url = `${baseUrl}/lot/${itemCd}`;

	return await getData<ResponseDto<PRD3012_R01LotDto[]>>(url);
}

export const getPRD3012_R01StockLot = async (productResultNo: string) => {
	const url = `${baseUrl}/lot/stock/${productResultNo}`;

	return await getData<ResponseDto<PRD3012_R01LotDto[]>>(url);
}

export const postPRD3012_R01StockLot = async (data: PRD3012_R01Dto) => {
	const url = `${baseUrl}/lot/stock`;

	return await postData<PRD3012_R01Dto, ResponseDto<PRD3012_R01Dto>>(url, data);
}

export const getPRD3012_R01DetailList = async (
	productOrderNo: string,
	itemCd: string,
	productQty: number,
	badQty: number,
	outWarehouseCd: string,
	logicCenter: string,
	workplaceCd: string,
) => {
	const url = `${baseUrl}/detail`;

	return await getData<ResponseDto<PRD3012_R01DetailDto[]>>(url, { params: {
			productOrderNo,
			itemCd: itemCd,
			productQty: productQty,
			badQty: badQty,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter,
			workplaceCd: workplaceCd,
		}
	});
}

export const getPRD3012_R01DetailStockList = async (
	productOrderNo: string,
	itemCd: string,
	outWarehouseCd: string,
	logicCenter: string,
) => {
	const url = `${baseUrl}/detail/stock`;

	return await getData<ResponseDto<PRD3012_R01DetailDto[]>>(url, { params: {
			productOrderNo,
			itemCd: itemCd,
			outWarehouseCd: outWarehouseCd,
			logicCenter: logicCenter,
		}
	});
}

export const getPRD3012_R01TransportedInfo = async (productResultNo: string) => {
	const url = `${baseUrl}/detail/transported`;
	return await getData<ResponseDto<PRD3012_R01DetailDto[]>>(url, {
		params: {
			productResultNo: productResultNo
		}
	});
}

export const getPRD3012_R01InspectList = async (productResultNo: string) => {
	const url = `${baseUrl}/inspect/${productResultNo}`;

	return await getData<ResponseDto<PRD3012_R01InspectDto[]>>(url);
}

export const postPRD3012_R01Inspect = async (data: PRD3012_R01Dto) => {
	const url = `${baseUrl}/inspect`;

	return await postData<PRD3012_R01Dto, ResponseDto<PRD3012_R01Dto>>(url, data);
}

export const deletePRD3012_R01Inspect = async (data: PRD3012_R01Dto) => {
	const url = `${baseUrl}/inspect`;

	return await deleteDataList<PRD3012_R01Dto, ResponseDto<void>>(url, data);
}

export const createPRD3012_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postPRD3012_R01 = async (data: PRD3012_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<PRD3012_R01Dto, ResponseDto<PRD3012_R01Dto>>(url, data);
}

export const patchPRD3012_R01 = async (data: PRD3012_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<PRD3012_R01Dto, ResponseDto<PRD3012_R01Dto>>(url, data);
}

export const patchPRD3012_R01WorkStart = async (productOrderNo: string, timeParam: string) => {
	const url = `${baseUrl}/workStart`;
	const data = { productOrderNo: productOrderNo, timeParam: timeParam } as PRD3012_R01HeaderDto;
	return await patchData<PRD3012_R01HeaderDto, ResponseDto<PRD3012_R01HeaderDto>>(url, data);
}

export const patchPRD3012_R01WorkEnd = async (productOrderNo: string, timeParam: string) => {
	const url = `${baseUrl}/workEnd`;
	const data = { productOrderNo: productOrderNo, timeParam: timeParam } as PRD3012_R01HeaderDto;
	return await patchData<PRD3012_R01HeaderDto, ResponseDto<PRD3012_R01HeaderDto>>(url, data);
}

export const deletePRD3012_R01 = async (purchaseBillNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseBillNo
		}
	});
}

export const downloadExcel_PRD3012_R01 = async (option: string, purchaseBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseBillNo
		}
	})
}

export const getPdfBlob_PRD3012_R01 = async (productResultNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { productResultNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
